import { useMemo } from 'react';

import type { HighlightOptions } from './types';
import { highlightWords } from './util';

export const useHighlight = (props: HighlightOptions) => {
  const { text, query } = props;
  return useMemo(() => highlightWords({ text, query }), [text, query]);
};
